<template>
  <div class="recruit" id="recruit">
	<div class="recruit-top">
		<div class="person-img"><img :src="spread_info.avatar" alt=""></div>
		<div class="person-name">{{spread_info.nickname}}</div>
		<div class="person-name">邀请你成为分销员</div>
	</div>
	<div class="recruit-img"><img src="@assets/images/recruit_img.png" alt=""></div>
	<div class="task-box">
		<div class="task-top">- 如何达到申请指标 -</div>
		<div class="task-list">
			<div class="task-left"><img src="@assets/images/close.gif" alt=""></div>
			<div class="task-center">
				<p>购买商品</p>
				<p style="color: #999;">需购买指定商品礼包</p>
			</div>
			<router-link to="/user/recruit_buy"><div v-if="task_status == 1" class="task-right">去消费</div></router-link>
			<div v-if="task_status == 2" class="task-right">已完成</div>
		</div>
	</div>
	<div style="height: 1.2rem;"></div>
	<input type="button" :class="bttton_dispaly ? 'recruit-footer' : 'recruit-footer disable'" @click="apply(jump_status)" :value="button_msg">
	<!-- 绑定手机号 -->
	<div v-if="maskShow1" class="mask">
		<div class="forminfo">
			<h2>绑定手机号
				<img class="mask_close" @click="closeMask(1)" src="@assets/images/index_close.png" alt="">
			</h2>
			<ul>
				<li><input type="number" v-model="phone" pattern="[0-9]*" placeholder="请输入手机号"></li>
				<li>
					<input type="number" v-model="codeVal" pattern="[0-9]*" placeholder="请输入验证码">
					<input type="button" value="获取验证码" :class="iscode ? 'getcode' : 'graycode'" id="code" @click="clickGetCode()" :disabled="!iscode">
				</li>
			</ul>
			<input class="button" type="button" @click="bind()" value="绑定手机号">
		</div>
	</div>
	<!-- 填写审核信息 -->
	<div v-if="maskShow2" class="mask">
		<div class="form-apply">
			<h2>填写审核信息
				<img class="mask_close" @click="closeMask(2)" src="@assets/images/index_close.png" alt="">
				<p>商家设置了信息审核，请填写真实信息</p>
			</h2>
			<ul>
				<li v-for="(item,key) in recruit_info" :key="key">
					<span v-if="item.must == 1" class="red">*</span>
					<span class="input-text">{{item.text}}:</span>
					<input :type="item.select == 'phone' ? 'number' : 'text'" v-model="tagModel[item.name]" :placeholder="'请输入'+item.text">
				</li>
			</ul>
			<input class="button" type="button" @click="next()" value="下一步">
		</div>
	</div>
  </div>
</template>

<script>
import { parseQuery } from "@utils";
import { getRecruitIndex, registerVerify, getCodeApi, bindingPhone, recruitAdd } from "@api/user";
export default {
  name: "RecruitIndex",
  data: function() {
    return {
	  urlSpread:"",
      maskShow1:false,
      maskShow2:false,
	  phone:"",
	  codeVal:"",
	  iscode:false,
	  keyCode:"",
	  button_msg:"",
	  spread_info:{},
	  task_status:2,//是否需要做任务
	  jump_status:1,
	  bttton_dispaly:true,
	  alert_msg:"",
	  recruit_info:[],
	  tagModel: {},//循环v-model
	  defaultHeight: '0',  //默认屏幕高度
	  nowHeight:  '0',  //实时屏幕高度
    };
  },
  watch:{
	phone(){
		let phone = this.phone;
		if((/^1[3456789]\d{9}$/.test(phone))){
			this.iscode = true;
		}else{
			this.iscode = false;
		}
	},
	$route(n,from) {
		if (n.name === "OrderSubmission") {
			this.$cookies.set("iszfbshow","1");
			location.reload();
		}
	},
	nowHeight:function() {
		if(this.defaultHeight!= this.nowHeight){
		 //键盘弹出操作
		}else{
		 //键盘不弹出操作
		}
	}
  },
  mounted: function() {
    let query = parseQuery();
    this.urlSpread = query["spread"];
	this.$cookies.set("urlSpread",this.urlSpread);
	this.recruitIndex();
	this.getCode();
	document.body.addEventListener('focusout', () =>{
		window.scrollTo(0,0);
	})
	document.body.addEventListener('focusin', () =>{
		var height = window.innerHeight;
		window.scrollTo(0,height);
	})
	//获取默认高度
	this.defaultHeight = window.innerHeight;
	window.onresize = () => {
		return (() => {
		   //实时屏幕高度
		   this.nowHeight = window.innerHeight;
		})();
	};
  },
  methods: {
	recruitIndex: function(){
		let that = this;
		getRecruitIndex({spread:this.urlSpread}).then(res => {
			that.button_msg = res.data.button_msg;
			that.spread_info = res.data.info.spread_info;
			that.task_status = res.data.task_status;
			that.jump_status = res.data.jump_status;
			that.bttton_dispaly = res.data.bttton_dispaly;
			that.alert_msg = res.data.alert_msg;
			that.recruit_info = res.data.info.recruit_info;
			res.data.info.recruit_info.forEach(item => {
				that.$set(this.tagModel, item.name, "");
			});
		}).catch(err => {
			that.$dialog.error(err);
		});
	},
    apply: function(status) {
		let that = this;
		if(that.alert_msg != ''){
			that.$dialog.toast({mes:that.alert_msg})
		}
		if(status == 1){
			that.maskShow1 = true;
		}
		if(status == 2){
			if(!that.bttton_dispaly){
				that.maskShow2 = false;
			}else{
				that.maskShow2 = true;
				document.getElementById("recruit").classList.add("noscoll");
			}
		}
		if(status == 3){
			console.log("审核中")
		}
		if(status == 4){
			if(!that.bttton_dispaly){
				that.maskShow2 = false;
			}else{
				that.maskShow2 = true;
				document.getElementById("recruit").classList.add("noscoll");
			}
		}
		if(status == 5){
			that.$router.push("/user/user_promotion");
		}
    },
	closeMask: function(status){
		document.getElementById("recruit").classList.remove("noscoll");
		if(status == 1){
			this.maskShow1 = false;
		}
		if(status == 2){
			this.maskShow2 = false;
		}
	},
	getCode() {
	  getCodeApi()
	    .then(res => {
	      this.keyCode = res.data.key;
	    })
	    .catch(res => {
	      this.$dialog.error(res.msg);
	    });
	},
	clickGetCode: function(){
		let that = this;
		registerVerify({
			phone: that.phone,
			type: 'register',
			key: that.keyCode,
			code: that.codeVal
        }).then(res => {
			if(res.msg != "发送成功"){
			  that.$dialog.toast({mes:res.msg});
			  return false;
			}else{
				var count = 60;
				const countDown = setInterval(() => {
				  if (count === 0) {
				    document.getElementById('code').value = '重新发送';
					document.getElementById('code').removeAttribute('disabled');
					document.getElementById('code').style.color = '#5b5e7d';
				    clearInterval(countDown);
				  } else {
					document.getElementById('code').style.color = '#ccc';
					document.getElementById('code').value = '剩余' + count + '秒';
					document.getElementById('code').setAttribute('disabled',true);
				  }
				  count--;
				}, 1000);
			}
		}).catch(err => {
			that.$dialog.error(err.msg);
		});
	},
	bind: function(){
		let that = this;
		bindingPhone({
		  phone: that.phone,
		  captcha: that.codeVal,
		  code: ""
		}).then(res => {
		  that.$router.go(0);
		}).catch(res => {
		  that.$router.go(0);
          that.$dialog.error(res.msg);
        });
	},
	next: function(){
		let that = this;
		console.log(that.tagModel)
		let success = true;
		that.recruit_info.forEach(item => {
			if(item.must == 1){
				if(that.tagModel[item.name] == ''){
					that.$dialog.toast({mes:'请填写必填字段'})
					success = false;
				}
				if(item.select == 'phone'){
					let phone = that.tagModel[item.name];
					if(!(/^1[3456789]\d{9}$/.test(phone))){
						that.$dialog.toast({mes:'请填写正确的手机号码'})
						success =  false;
					}
				}
			}
		});
		if(success){
			recruitAdd({
			spread: that.urlSpread,
			info: that.tagModel
			}).then(res => {
				that.$router.go(0);
			}).catch(res => {
				that.$dialog.error(res.msg);
			});
		}else{
			return false;
		}

	}
  }
};
</script>
<style scoped>
	.noscoll{
		height: 100%;
		overflow: hidden;
	}
	.recruit-top{
		padding: 0.2rem;
		background-color: #fff;
		overflow: hidden;
	}
	.recruit-top div{
		float: left;
		margin-left: 0.1rem;
	}
	.person-img{
		width: 0.85rem;
	}
	.person-img img{
		display: block;
		width: 100%;
	}
	.person-name{
		margin-top: 0.2rem;
	}
	.recruit-img{
		padding: 0.2rem;
		margin-bottom: 0.2rem;
		margin-top: 0.2rem;
		background-color: #fff;
	}
	.recruit-img img{
		display: block;
		width: 100%;
	}
	.task-box{
		overflow: hidden;
		background-color: #fff;
		padding: 0.4rem 0.55rem;
	}
	.task-top{
		font-size: 0.4rem;
		text-align: center;
		line-height: 0.7rem;
	}
	.task-list{
		margin-top: 0.5rem;
		overflow: hidden;
	}
	.task-left,.task-center{
		float: left;
	}
	.task-left img{
		width: 0.9rem;
		height: 0.9rem;
	}
	.task-center{
		margin-left:0.3rem;
	}
	.task-right{
		width: 2rem;
		height: 0.7rem;
		line-height: 0.7rem;
		text-align: center;
		float: right;
		color: #5dc47b;
		border: 1px solid #5dc47b;
		border-radius: 17px;
		margin-top: 0.1rem;
	}
	.recruit-footer{
		width: 100%;
		height: 1rem;
		background-color: #1fbb61;
		color: #fff;
		font-size: 0.3rem;
		text-align: center;
		line-height: 1rem;
		position: fixed;
		left: 0;
		bottom: 0;
	}
	.disable{
		background-color: #9addb4;
	}
	.forminfo{
		width: 100%;
		padding: 0.8rem 0.4rem;
		border-radius: 10px 10px 0 0;
		background-color: #fff;
		position: fixed;
		bottom: 0;
		left: 0;
	}
	.form-apply{
		width: 100%;
		padding: 0.4rem;
		border-radius: 10px 10px 0 0;
		background-color: #fff;
		position: fixed;
		bottom: 0;
		left: 0;
	}
	.mask_close{
		position: absolute;
		top: -0.15rem;
		right: 0;
		width: 0.5rem;
	}
	.forminfo h2{
		font-size: 0.4rem;
		margin-bottom: 0.4rem;
		position: relative;
	}
	.form-apply h2{
		font-size: 0.4rem;
		position: relative;
	}
	.forminfo h2 p,.form-apply h2 p{
		font-weight: normal;
		font-size: 0.26rem;
		color: #999;
	}
	.forminfo ul li{
		border-bottom: 1px solid #e2e2e2;
		height: 1.35rem;
		line-height: 1.35rem;
	}
	.form-apply ul li{
		border-bottom: 1px solid #e2e2e2;
		height: 1rem;
		line-height: 1rem;
	}
	.input-text{
		display: inline-block;
		margin-right: 0.2rem;
		width: 26%;
		line-height: 0.35rem;
		margin-left: 0.1rem;
		margin-top: 0.15rem;
	}
	.red{
		color: red;
	}
	.forminfo ul li input{
		height: 1rem;
	}
	.form-apply ul li input{
		width: 67%;
		float: right;
		height: 1rem;
	}
	.forminfo ul li .getcode{
		float: right;
		color: #5b5e7d;
		height: 1.35rem;
		line-height: 1.35rem;
	}
	.forminfo ul li .graycode{
		float: right;
		color: #ccc;
		height: 1.35rem;
		line-height: 1.35rem;
	}
	.button{
		display: block;
		width: 90%;
		margin: 0 auto;
		height: 1rem;
		line-height: 1rem;
		text-align: center;
		background-color: #1fbb61;
		color: #fff;
		margin-top: 1.2rem;
		border-radius: 3px;
		font-size: 0.3rem;
	}
	.form-apply .button{
		margin-top: 0.2rem;
	}
</style>
